const styles = theme => ({
  root: {
    padding: 6,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    outline: 'none',
    '&.MuiIconButton-root:focus': {
      outline: 'none',
    },
  },
  filled: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  outlined: {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  scrollbars: {
    // border: '1px solid #CDCDCD',
    borderRadius: '0 0 4px 4px',
    boxSizing: 'border-box',
  },
});
export default styles;
